// src/Web3.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import BannerWithCard_Web3 from '../components/BannerWithCard_Web3';
import Web3Section2 from '../components/Web3Section2';
import Web3Section3 from '../components/Web3Section3';
import Web3Section4 from '../components/Web3Section4';
import Web3Section5 from '../components/Web3Section5';


const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;


function Web3() {



  return (

    <Container>
   
        <Navbar />
        <BannerWithCard_Web3 /> 
        <Web3Section2 />
        <Web3Section3 />
        <Web3Section4 />
        <Web3Section5 />
        


        <Footer /> 

    </Container>

  );
}

export default Web3;